// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// #####################################################

const DataLanguages = () => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const userLanguages = useSelector(
		(state) => state.userProfileMain.languages,
	);

	// #####################################################

	return (
		<Block>
			<Text mr={1}>{t("filtersAndSelectors:languageLabel")}:</Text>
			<Text bold>
				{[...userLanguages]
					.sort((a, b) => {
						return t(`languages:${a}`).localeCompare(
							t(`languages:${b}`),
							undefined,
							{
								numeric: false,
								sensitivity: "base",
							},
						);
					})
					.map((item) => t(`languages:${item}`))
					.join(`, `)}
			</Text>
		</Block>
	);
};

// #####################################################

export default DataLanguages;

// #####################################################
